module.exports = require('./helpers/bundle-url').getBundleURL('eVKW7') + "logo.c5857b8b.svg";